import { MedrecordMoment } from '@medrecord/services-datetime';
import { ResourceType } from '../enums/resource-type.enum';
import { ResourceBlockFunction } from '../interfaces/resource-block-function.interface';

export const bodyHeightBlock: ResourceBlockFunction = () => ({
  resourceType: ResourceType.observation,
  fieldGroups: [
    {
      name: ({ resource }) =>
        [
          resource.content?.effective?.date ? MedrecordMoment(resource.content?.effective?.date).format('LL') : null,
          [resource.content?.height?.value, resource.content?.height?.unit].filter(Boolean).join(''),
        ]
          .filter(Boolean)
          .join(' - ') || 'my_doctor_measurement',
      fields: [
        {
          label: 'my_doctor_position',
          fieldName: 'position',
          translate: true,
          prepareData: (data) => (data ? 'measurements_body_height_position_' + data?.toLowerCase() : null),
        },
        {
          label: 'my_doctor_comment',
          fieldName: 'comment',
          prepareData: (data) => data,
        },
        {
          label: 'my_doctor_care_provider',
          fieldName: 'performer',
          prepareData: (data) => data?.display,
        },
        
      ]
    },
  ],
});
